import { Box, Button, Stack, TextField } from '@mui/material';
import { useForm } from 'app/hooks';
import { Typography } from 'app/shared';
import { IMedicalCenterDeleteSchema } from 'generated/axios';
import { t } from 'i18next';
import _ from 'lodash';

interface Props {
  onConfirmFn: (form: IMedicalCenterDeleteSchema) => void;
  onCancelFn: () => void;
  medicalCenterEmail: string;
}

export const MedicalCenterConfirmDeleteDialog = ({ onConfirmFn, medicalCenterEmail, onCancelFn }: Props) => {
  const { submit, bindTextField, form } = useForm<IMedicalCenterDeleteSchema>({
    onSubmit: onConfirmFn,
  });

  return (
    <Box sx={{ backgroundColor: 'common.white' }}>
      <Typography padding={3} sx={{ backgroundColor: 'primary.main', color: 'common.white' }}>
        {t('actions.delete')}
      </Typography>
      <Typography padding={3}>{t('medicalCenter.confirmDeleteMessage')}</Typography>
      <TextField sx={{ marginX: 3 }} {...bindTextField({ field: 'user_email' })} />
      <Stack padding={3} spacing={2} direction={'row'}>
        <Button
          variant="contained"
          color="error"
          onClick={submit}
          disabled={!_.isEqual(medicalCenterEmail, form.user_email)}
        >
          {t('actions.delete')}
        </Button>
        <Button variant="text" onClick={onCancelFn}>
          {t('actions.cancel')}
        </Button>
      </Stack>
    </Box>
  );
};
